import { SELLERS_ACTIONS_TYPES } from "./sellers.types";

import { createAction } from "../../utils/reducer/reducer";


export const setSellers = (sellers) => {
	return createAction(SELLERS_ACTIONS_TYPES.SET_SELLERS, sellers);
};

export const setDocsTypes = (sellers) => {
	return createAction(SELLERS_ACTIONS_TYPES.SET_TYPEDOCS, sellers);
};

export const setSellersUpdated = (seller) => {
	return (dispatch, getState) => {
		// Access the current state
		const state = getState();
		console.log('state:', state);
		const currentSellers = state.sellers.sellers
		console.log('current Sellers: ', currentSellers)


		const currentSellerInArray = currentSellers.find((data) => data.id === seller.id)
		console.log('current Seller inside Array: ', currentSellerInArray)
		const { kits_inadimplentes } = currentSellerInArray
		const updatedNedSeller = {...seller, kits_inadimplentes: kits_inadimplentes}
		console.log('seller to update as response:', updatedNedSeller);
		// Log for debugging

		const updatedArray = currentSellers.filter((data) => data.id !== seller.id)
		console.log('sellers Whitout other: ', updatedArray)
		const newArr = [...updatedArray, updatedNedSeller]
		const sortedArr = newArr.sort((a, b) => a.nome.localeCompare(b.nome))
		dispatch(createAction(SELLERS_ACTIONS_TYPES.SET_SELLERS, sortedArr));
	};
};

export const insertNewSeller = (seller) => {
	return (dispatch, getState) => {
		// Access the current state
		const state = getState();
		console.log('state:', state);
		const currentSellers = state.sellers.sellers
		console.log('current Sellers: ', currentSellers)
		

		const updatedNedSeller = {...seller, kits_inadimplentes: []}
		console.log('seller to update as response:', updatedNedSeller);
		
		// Log for debugging
		const updatedArray = currentSellers.filter((data) => data.id !== seller.id)
		console.log('sellers Whitout other: ', updatedArray)
		
		const newArr = [...updatedArray, updatedNedSeller]
		const sortedArr = newArr.sort((a, b) => a.nome.localeCompare(b.nome))
		dispatch(createAction(SELLERS_ACTIONS_TYPES.SET_SELLERS, sortedArr));
	};
};